// extracted by mini-css-extract-plugin
module.exports = {"applicationSelectInner":"TasksForm_applicationSelectInner__114v-","goToApplicationButton":"TasksForm_goToApplicationButton__FOG8l","createButton":"TasksForm_createButton__2o1WB"};